jQuery.noConflict();
jQuery(document).ready(function(){ 
  if( $('.duogallerytxt').length > 0 ) {
    $( ".duogallerytxt" ).each(function( index ) {
      var section = $(this).find($( ".duogallerytxt_upper" )).data( "section" );
      // console.log(section);
      var allitems = $(this).find($('.duogallerytxt_item-'+section)).length;
      // console.log(allitems);
      $('.duogallerytxt_item-'+section).hide();
      $('.duogallerytxt_button-'+section).hide();
      if ($(window).width() < 1025) {
        var items = 4;
      }
      else {
        var items = 5;
      }
      if ( allitems > items ) {
        $( '.duogallerytxt_button-'+section ).show();
      }
      $('.duogallerytxt_item-'+section+':lt('+items+')').show();
      // Afficher 2 fichiers en plus en cliquant sur le boutton voir plus
      $( '.duogallerytxt_button-'+section ).click(function() {
        if ($(window).width() < 1025) {
          items = items + 3;
          $('.duogallerytxt_item-'+section+':lt('+items+')').show();
        }
        else {
          items = items + 4;
          $('.duogallerytxt_item-'+section+':lt('+items+')').show();
        }
        $('.duogallerytxt_item-'+section+':lt('+items+')').show();
        if ( items >= allitems ) {
          $( '.duogallerytxt_button-'+section ).hide();
        }
      });
      $( '.duogallerytxt_button-'+section ).keypress(function (e) {
        var key = e.which;
        if( (key == 13) || (key == 32) ) 
        {
          if ($(window).width() < 1025) {
            items = items + 3;
            $('.duogallerytxt_item-'+section+':lt('+items+')').show();
          }
          else {
            items = items + 4;
            $('.duogallerytxt_item-'+section+':lt('+items+')').show();
          }
          if ( items >= allitems ) {
            $( '.duogallerytxt_button-'+section ).hide();
          }
          return false;
        }
      });
      // End
    });    
    // End

  }
});
